const MANAGING_VIEWER_ROLES = new Set([
  'manager',
  'staff',
  'hotel_manager',
]);

export const isManagingEvent = (event) => (
  MANAGING_VIEWER_ROLES.has(event?.viewer_role)
);
